import { IMessagingService } from "../services";
import { Component } from "./component";
class SearchForm extends Component {
    protected searchForm: HTMLFormElement;
    protected searchFormInput: HTMLInputElement;
    protected resetCloseBtn: HTMLButtonElement;
    protected submitBtn: HTMLButtonElement;
    protected scrollPadding: string;

    private oncloseBtnClick: EventListener;
    private onFocusInput: EventListener;
    private onBlurInput: EventListener;

    constructor(componentEl: HTMLFormElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        this.searchForm = componentEl;
        this.searchFormInput = this.searchForm.querySelector(".js-search-form-input");

        if (!this.searchFormInput) {
            return; // no form found
        }

        this.resetCloseBtn = this.searchForm.querySelector(".js-search-form-reset-close-btn");
        this.submitBtn = this.searchForm.querySelector(".js-search-form-submit");

        this.oncloseBtnClick = this.oncloseBtnClickHandler.bind(this);
        this.onFocusInput = this.onFocusInputHandler.bind(this);
        this.onBlurInput = this.onBlurInputHandler.bind(this);

        this.init();
    }

    protected async init() {
        // Bind Event Handlers
        if (this.resetCloseBtn) {
            this.resetCloseBtn.addEventListener("click", this.oncloseBtnClick);
        }
        this.searchFormInput.addEventListener("focus", this.onFocusInput);
        this.searchFormInput.addEventListener("blur", this.onBlurInput);
    }

    private oncloseBtnClickHandler() {
        this.searchFormInput.value = "";
        this.searchFormInput.dispatchEvent(new Event("input"));
        this.searchFormInput.focus();
    }

    private onFocusInputHandler() {
        this.scrollPadding = document.documentElement.style.getPropertyValue("--scroll-padding");
        document.documentElement.style.setProperty("--scroll-padding", "0px");
    }

    private onBlurInputHandler() {
        document.documentElement.style.setProperty("--scroll-padding", this.scrollPadding);
    }
}

export { SearchForm };
